module.exports = __webpack_public_path__ + "static/media/PM36.9d869437.png";